var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.249 49.375C47.4521 49.375 44.374 52.453 44.374 56.25C44.374 57.501 44.7071 58.6727 45.2907 59.683L54.682 50.2917C53.6717 49.7081 52.5 49.375 51.249 49.375ZM57.298 52.979L47.978 62.299C48.9506 62.8263 50.0642 63.125 51.249 63.125C55.046 63.125 58.124 60.047 58.124 56.25C58.124 55.0652 57.8253 53.9516 57.298 52.979ZM40.624 56.25C40.624 50.382 45.381 45.625 51.249 45.625C54.2216 45.625 56.9119 46.8482 58.8382 48.814C60.7142 50.7284 61.874 53.3556 61.874 56.25C61.874 62.118 57.117 66.875 51.249 66.875C48.3547 66.875 45.7274 65.7152 43.813 63.8392C41.8472 61.9129 40.624 59.2226 40.624 56.25Z",
    fill: "#131315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9995 25C49.9995 30.5229 45.5224 35 39.9995 35C34.4767 35 29.9995 30.5229 29.9995 25C29.9995 19.4772 34.4767 15 39.9995 15C45.5224 15 49.9995 19.4772 49.9995 25Z",
    fill: "#131315"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7372 42.9698C40.5336 45.1322 36.8745 50.2638 36.8745 56.25C36.8745 59.5408 37.9852 62.5787 39.844 64.9999C19.9995 64.9738 19.9995 59.9471 19.9995 53.75C19.9995 47.5368 28.9538 42.5 39.9995 42.5C41.9937 42.5 43.9198 42.6642 45.7372 42.9698Z",
    fill: "#131315"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUser);
export default __webpack_public_path__ + "static/media/blockUser.95722986b628e26a138c4eb507b2d78b.svg";
export { ForwardRef as ReactComponent };